export default state =>
  state &&
  state.me &&
  state.agent &&
  (state.me.isLoading ||
    state.agent.isLoading ||
    !state.agent.isDeviceReady ||
    !state.agent.isWorkerReady);
